import { render, staticRenderFns } from "./SmLeaderboard.vue?vue&type=template&id=5344307c&scoped=true"
import script from "./SmLeaderboard.vue?vue&type=script&lang=js"
export * from "./SmLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./SmLeaderboard.vue?vue&type=style&index=0&id=5344307c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344307c",
  null
  
)

export default component.exports